<template>
    <div class="sa-dialog" @click.self="$emit('close')">
        <div class="sa-dialog-body sa-extra-small sa-text-center">
            <i class="icon-close sa-close" @click="$emit('close')"></i>
            <h5 class="sa-dialog-header">Reason for reschedule</h5>
            <textarea class="sa-form-control sa-form-control-lg sa-form-c-lg" id="Reshedule" v-model="reason" name="Reshedule" placeholder="Add text" @input="disBtn"></textarea>
            <p v-if="!reason && btnFlag" class="sa-red-text sa-mt10">Please Enter the reason of Reschedule</p>
            <button :disabled="hideReq" class="sa-btn sa-btn-large sa-btn-primary sa-mt30 sa-btn-block" @click="rescheduleApp">Send request</button>
        </div>
    </div>
</template>
<script>
import { oh_url } from '../../../config/endpoints';
export default {
    data() {
        return {
            reason:"",
            btnFlag: false,
            hideReq:false
        }
    },
    methods:{
        rescheduleApp() {
            this.hideReq = true
            let _self = this;
            _self.btnFlag = true
            if (_self.reason) {
                let req = {
                    apnt_id: _self.$route.params.appid,
                    reason: _self.reason,
                };
                _self.$store.dispatch("httpPost", {
                    uri: `${oh_url}/pro2/rescheduleRequest`,
                    body: req
                }).then((response) => {
                    if (response && response.status === 1000) {
                            _self.$router.go(-1)
                            _self.$store.dispatch("SET_ALERTMESSAGE", {
                            msg: response.data,
                            class: "sa-a-success"
                        });
                    }else {
                        _self.$store.dispatch("SET_ALERTMESSAGE", {
                            msg: "Something went wrong",
                            class: "sa-a-danger"
                        });
                    }
                });
            }
        },
        disBtn(){
            this.hideReq = false
        }
    }
}
</script>
<style scoped>
.sa-dialog-header {
    position: absolute;
    top: 15px;
    left: 50px;
}
.sa-dialog textarea{background-color: #F4F9FF;margin-top: 30px;}
.sa-close {
    right: 15px;
    top: 15px;
    font-size: 12px;
    border: 1px solid #000;
    border-radius: 50%;
    padding: 5px;
    cursor: pointer;
}
</style>